// import Chart from 'react-apexcharts';

const PieChart = (props) => {
  // const { series, options } = props;

  return (
    // <Chart
    //   options={options}
    //   type="pie"
    //   width="100%"
    //   height="100%"
    //   series={series}
    // />
      <iframe
        src="https://codesandbox.io/embed/nice-water-1v4hzb?fontsize=14&hidenavigation=1&initialpath=%2Fpie-chart&theme=dark&view=preview"
        width="100%"
        height="200px"
        ms="-15px"
        overflow="hidden"
      ></iframe>
  );
};

export default PieChart;
